import { render, staticRenderFns } from "./TravelList.vue?vue&type=template&id=4e924434"
import script from "./TravelList.vue?vue&type=script&lang=js"
export * from "./TravelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports